const { default: Splide } = require("@splidejs/splide");

// document.addEventListener("DOMContentLoaded", () => {
//     const searchBar = document.querySelector("header .header-search");

//     if (searchBar) {
//         const button = document.querySelector("header .search-button");
//         const close = document.querySelector("header .close-search-button");

//         if (button) {
//             button.addEventListener("click", (e) => {
//                 e.preventDefault();

//                 searchBar.classList.add("is-visible");
//             });
//         }

//         if (close) {
//             close.addEventListener("click", (e) => {
//                 e.preventDefault();

//                 searchBar.classList.remove("is-visible");
//             });
//         }

//         document.addEventListener("click", (e) => {
//             if (!searchBar.contains(e.target) && !button.contains(e.target)) {
//                 searchBar.classList.remove("is-visible");
//             }
//         });
//     }
// });


document.addEventListener('DOMContentLoaded', function () {
    // Get all the nav links inside the navbar
    var navLinks = document.querySelectorAll('.wp-block-klingit-basic-submenu a');

    navLinks.forEach(function (link) {
        if (link.href === window.location.href) {
            link.style.textDecoration = 'underline';
            link.classList.add('active');
        }

        // Check if the link or its parent has the 'not-link' class
        if (link.classList.contains('not-link') || link.parentElement.classList.contains('not-link')) {
            console.log('Preventing navigation for:', link); // Debug log

            link.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation(); // Stop the event from bubbling up
            });
        }
    });
});
document.addEventListener('DOMContentLoaded', function () {
    // Array of selectors for the img tags to replace with SVG
    const selectors = ['.zimpler-icon img[src$=".svg"]'];

    // Function to replace img with SVG content
    function replaceImgWithSVG(imgElement) {
        const imgUrl = imgElement.getAttribute('src');

        fetch(imgUrl)
            .then(response => response.text())
            .then(svgContent => {
                const svgContainer = document.createElement('div');
                svgContainer.innerHTML = svgContent;
                const svgElement = svgContainer.querySelector('svg');

                if (imgElement.getAttribute('class')) svgElement.setAttribute('class', imgElement.getAttribute('class'));
                if (imgElement.getAttribute('style')) svgElement.setAttribute('style', imgElement.getAttribute('style'));
                if (imgElement.getAttribute('width')) svgElement.setAttribute('width', imgElement.getAttribute('width'));
                if (imgElement.getAttribute('height')) svgElement.setAttribute('height', imgElement.getAttribute('height'));
                if (imgElement.getAttribute('alt')) svgElement.setAttribute('aria-label', imgElement.getAttribute('alt'));

                imgElement.parentNode.replaceChild(svgElement, imgElement);
            })
            .catch(error => console.error('Error fetching SVG:', error));
    }

    // Initialize IntersectionObserver
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                replaceImgWithSVG(entry.target);
                observer.unobserve(entry.target); // Stop observing the current target
            }
        });
    }, {
        rootMargin: '0px',
        threshold: 0.1
    });

    // Observe each `img` element that matches the selectors
    selectors.forEach(selector => {
        const imgElements = document.querySelectorAll(selector);
        imgElements.forEach(img => observer.observe(img));
    });
});


document.addEventListener('DOMContentLoaded', function () {
    // Function to apply border-radius from img to its ancestor with a specific class
    function applyBorderRadiusFromImgToAncestor(ancestorClass) {
        // Find all images within elements with the specified class
        var images = document.querySelectorAll(ancestorClass + ' img');

        // Loop through each image
        images.forEach(function (img) {
            // Get the computed style of the image
            var imgStyle = window.getComputedStyle(img);

            // Get the border-radius property value from the image
            var imgBorderRadius = imgStyle.getPropertyValue('border-radius');

            // Check if the image has a border-radius set (not '0px')
            if (imgBorderRadius !== '0px') {
                // Get the ancestor element with the specified class
                var ancestor = img.closest(ancestorClass);
                if (ancestor) {
                    // Get the computed style of the ancestor
                    var ancestorStyle = window.getComputedStyle(ancestor);

                    // Get the border-radius property value from the ancestor
                    var ancestorBorderRadius = ancestorStyle.getPropertyValue('border-radius');

                    // Only apply the border-radius to the ancestor if it's not already set
                    if (ancestorBorderRadius === '0px') {
                        ancestor.style.borderRadius = imgBorderRadius;
                    }
                }
            }
        });
    }

    // Apply border-radius for both simple image block and cover block
    applyBorderRadiusFromImgToAncestor('.is-style-zimpler-zoom-image');
    applyBorderRadiusFromImgToAncestor('.wp-block-cover.is-style-zimpler-zoom-image');
});
document.addEventListener('DOMContentLoaded', () => {

    setTimeout(() => {
        const tabsContainer = document.querySelector('.tabs-vertical .tabs-navigation');
        if (!tabsContainer) {
            // console.error('Tabs navigation container not found.');
            return;
        }

        // Create the dropdown element
        const dropdown = document.createElement('select');
        dropdown.id = 'mobileTabsDropdown';
        dropdown.classList.add('mobile-tabs-dropdown');

        // Populate the dropdown with options from tabs
        const tabs = tabsContainer.querySelectorAll('button');
        tabs.forEach(tab => {
            const option = new Option(tab.querySelector('[itemprop="name"]').textContent, tab.dataset.button);
            dropdown.add(option);
        });

        // Insert the dropdown into the DOM, before the tabs container
        tabsContainer.parentNode.insertBefore(dropdown, tabsContainer);

        // Event listener for changing tabs from dropdown
        dropdown.addEventListener('change', event => {
            // Trigger a click on the corresponding tab
            const activeTab = tabsContainer.querySelector(`button[data-button="${event.target.value}"]`);
            activeTab.click();
        });

        // Define and apply media query behavior
        const handleMobileView = mediaQuery => {
            if (mediaQuery.matches) {
                // If it's a mobile device, show dropdown and hide tabs
                dropdown.style.display = 'block';
                tabsContainer.style.display = 'none';
            } else {
                // If it's not a mobile device, show tabs and hide dropdown
                dropdown.style.display = 'none';
                tabsContainer.style.display = 'block';
            }
        };

        // Define a media query
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        handleMobileView(mediaQuery); // Call listener function at run time
        mediaQuery.addListener(handleMobileView); // Attach listener function on state changes
    }, 2000);

});


document.addEventListener("DOMContentLoaded", function () {
    // Select all accordion headings
    var accordionHeadings = document.querySelectorAll('.accordion-heading');

    // Function to toggle the accordion
    function toggleAccordion(heading) {
        // Find the accordion block related to the clicked heading
        var accordionBlock = heading.closest('.wp-block-column').querySelector('.accordion-block');
        if (accordionBlock) {
            // If this accordion is already active, close it, otherwise open it
            // accordionBlock.classList.toggle('accordion-block-active');
        }
    }

    // Function to remove active class from all other accordions except the current one
    function closeOtherAccordions(currentAccordion) {
        var allAccordionBlocks = document.querySelectorAll('.accordion-block');
        allAccordionBlocks.forEach(function (block) {
            if (block !== currentAccordion) {
                block.classList.remove('accordion-block-active');
            }
        });
    }

    // Add click event listener to each accordion heading
    accordionHeadings.forEach(function (heading) {
        heading.addEventListener('click', function () {
            var currentAccordion = this.closest('.wp-block-column').querySelector('.accordion-block');
            closeOtherAccordions(currentAccordion);
            toggleAccordion(this);
        });
    });
});
// Function to calculate and apply the header height
// function adjustFullHeightDisplay() {
//     // Get the header element
//     var header = document.querySelector('header'); // Replace 'header' with the correct selector for your header
//     // Get the computed style of the header
//     var headerStyle = window.getComputedStyle(header);
//     // Calculate the total height of the header
//     var headerHeight = header.offsetHeight;

//     // Get one of the full-height-display elements to calculate the bottom padding
//     // var fullHeightDisplaySample = document.querySelector('.full-height-display');
//     // Get the computed style of the element
//     // var fullHeightDisplayStyle = window.getComputedStyle(fullHeightDisplaySample);
//     // Get the bottom padding of the element
//     // var fullHeightDisplayPaddingBottom = parseInt(fullHeightDisplayStyle.paddingBottom);

//     // Calculate the height for '.full-height-display' elements, subtracting the header height and the bottom padding of the full-height-display element
//     var fullHeightDisplayHeight = window.innerHeight;

//     // Apply the height to all elements with the class '.full-height-display'
//     var fullHeightDisplays = document.querySelectorAll('.full-height-display');
//     fullHeightDisplays.forEach(function (elem) {
//         elem.style.height = fullHeightDisplayHeight + 'px';
//     });
// }

// Event listener for window load
// window.addEventListener('load', adjustFullHeightDisplay);

// // Event listener for window resize
// window.addEventListener('resize', adjustFullHeightDisplay);

// // Optional: Throttle resize event for performance
// function throttle(func, limit) {
//     var inThrottle;
//     return function () {
//         var args = arguments;
//         var context = this;
//         if (!inThrottle) {
//             func.apply(context, args);
//             inThrottle = true;
//             setTimeout(function () {
//                 inThrottle = false;
//             }, limit);
//         }
//     };
// }

// // Use the throttle function for the resize event
// var throttledAdjustFullHeightDisplay = throttle(adjustFullHeightDisplay, 100);
// window.removeEventListener('resize', adjustFullHeightDisplay); // Remove the non-throttled event listener
// window.addEventListener('resize', throttledAdjustFullHeightDisplay); // Add the throttled event listener




// document.addEventListener('DOMContentLoaded', function () {
//     // Check if the GTM dataLayer object exists
//     if (window.dataLayer && Array.isArray(window.dataLayer)) {
//         // Find the logo element
//         var logoElement = document.querySelector('.wp-block-site-logo .custom-logo');

//         if (logoElement) {
//             // Create a custom event with the 'Zimpler Logo' text
//             var gtmEvent = {
//                 'event': 'Logo Click',
//                 'gtm.element': logoElement,
//                 'gtm.elementClasses': logoElement.className,
//                 'gtm.elementId': logoElement.id,
//                 'gtm.elementTarget': logoElement.target,
//                 'gtm.elementUrl': logoElement.src,
//                 'gtm.elementText': 'Zimpler Logo' // The text you want to add
//             };

//             // Push the event to the GTM dataLayer
//             window.dataLayer.push(gtmEvent);

//             // console.log('Zimpler Logo GTM event pushed:', gtmEvent);
//         } else {
//             // console.warn('Zimpler Logo element not found or alt text does not match.');
//         }
//     } else {
//         // console.error('GTM dataLayer is not defined or is not an array.');
//     }
// });


// document.addEventListener('DOMContentLoaded', function () {
//     var form = document.querySelector('.wp-block-klingit-basic-form');
//     if (!form) return;
//     var fileInput = document.getElementById('attachment');
//     var fileError = document.createElement('span');
//     fileError.className = 'error error-visible';
//     fileError.style.display = 'none';
//     fileError.innerHTML = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.89583 4.89583L7.5 7.5M7.5 7.5L10.1042 10.1042M7.5 7.5L4.89583 10.1042M7.5 7.5L10.1042 4.89583M13.75 7.5C13.75 10.9518 10.9518 13.75 7.5 13.75C4.04822 13.75 1.25 10.9518 1.25 7.5C1.25 4.04822 4.04822 1.25 7.5 1.25C10.9518 1.25 13.75 4.04822 13.75 7.5Z" stroke-width="1.5"></path></svg>Please attach a file.';
//     // Insert error message after the file input
//     fileInput.parentNode.insertBefore(fileError, fileInput.nextSibling);

//     // Save a reference to the original formOnSubmit function
//     var originalFormOnSubmit = form.onsubmit;

//     // Extend the formOnSubmit function with additional validation
//     form.onsubmit = function (e) {
//         // Check if any file is selected
//         if (fileInput.files.length === 0) {
//             e.preventDefault(); // Prevent form submission
//             fileError.style.display = 'block'; // Show error message
//             return false; // Stop the execution of the extended function
//         } else {
//             fileError.style.display = 'none'; // Hide error message
//         }

//         // Call the original formOnSubmit function
//         if (originalFormOnSubmit) {
//             return originalFormOnSubmit.apply(this, arguments);
//         }
//     };
// });
